module.exports = __webpack_public_path__ + "fonts/InstagramSansCondensed-Regular.110cebca.ttf";